import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_b68c3l2ppb: FaireBrandEntity = {
  token: "b_b68c3l2ppb",
  type: "brand",
  name: "privé",
  avatarUrl:
    "https://cdn.faire.com/fastly/8437b4fe2e079f91ccfe28cd5cc667358eab8166589e85eeca20f48ae5d13819.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/e59019096ee80b39063953f681911ee5760083f54116ddb1be542e09985874f3.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/8437b4fe2e079f91ccfe28cd5cc667358eab8166589e85eeca20f48ae5d13819.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/e59019096ee80b39063953f681911ee5760083f54116ddb1be542e09985874f3.jpeg",
  location: "Menominee, MI, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description:
    "as a woman owned, women led company, we are inspired to do good for the world and feel good about the change you create.  our intent is on using business as a force for good.  we are passionate about giving back.  whenever you make a privé purchase, you are helping us help others.  privé gives 1% of every sale to a non-profit-organization, Project Beauty Share, who help women restore their hope, dignity and strength.\n\nwe are a conscious beauty brand with a passion for small-batch, artisan products that we know you will love.  privé is a salon quality hair care brand using the highest quality natural and organic ingredients that are good for you and the planet.  formulas you can trust.  enriched with food grade super fuel antioxidants, revitalizing natural oils and strengthening proteins.  we never formulate with harsh chemicals or toxic preservatives like SLS, harsh sulfates, sodium chloride, or artificial dyes.  we are gluten free and color safe.\n\nwe aspire each day to be a force for your personal beauty that reflects our privé values: responsible, authentic, transparent, sustainable, and cruelty free.\n\n\n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:22.234Z",
    importedBy: "entity-db-cli",
  },
};
